(function ($) {
  "use strict";

  var browserWindow = $(window);

  // :: 1.0 Preloader Active Code
  browserWindow.on("load", function () {
    $(".preloader").fadeOut("slow", function () {
      $(this).remove();
    });
  });

  // :: 2.0 Nav Active Code
  if ($.fn.classyNav) {
    $("#croseNav").classyNav();
  }

  // :: 3.0 Search Active Code
  $("#header-search").on("click", function () {
    $(".search-form-area").toggleClass("search-on");
  });
  $("#searchCloseIcon").on("click", function () {
    $(".search-form-area").removeClass("search-on");
  });

  // :: 4.0 Sliders Active Code
  if ($.fn.owlCarousel) {
    var welcomeSlide = $(".hero-post-slides");
    var upcomingSlides = $(".upcoming-slides");

    welcomeSlide.owlCarousel({
      items: 1,
      margin: 0,
      loop: true,
      nav: false,
      dots: false,
      autoplay: true,
      center: true,
      autoplayTimeout: 7000,
      smartSpeed: 1000,
    });

    var animPrefix = 'animate__'

    welcomeSlide.on("translate.owl.carousel", function () {
      var slideLayer = $("[data-animation]");
      slideLayer.each(function () {
        var anim_name = $(this).data("animation");
        $(this)
          .removeClass(animPrefix + "animated " + animPrefix + anim_name)
          .css("opacity", "0");
      });
    });

    welcomeSlide.on("translated.owl.carousel", function () {
      var slideLayer = welcomeSlide
        .find(".owl-item.active")
        .find("[data-animation]");
      slideLayer.each(function () {
        var anim_name = $(this).data("animation");
        $(this)
          .addClass(animPrefix + "animated " + animPrefix + anim_name)
          .css("opacity", "1");
      });
    });

    $("[data-delay]").each(function () {
      var anim_del = $(this).data("delay");
      $(this).css('animation-delay', anim_del);
    });

    $("[data-duration]").each(function () {
      var anim_dur = $(this).data("duration");
      $(this).css('animation-duration', anim_dur);
    });

    upcomingSlides.owlCarousel({
      items: 1,
      margin: 0,
      loop: true,
      nav: true,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      dots: false,
      autoplay: true,
      autoplayTimeout: 7000,
      smartSpeed: 1500,
    });
  }

  // :: 5.0 magnificPopup Active Code
  if ($.fn.magnificPopup) {
    $(".gallery-img").magnificPopup({
      gallery: {
        enabled: true,
      },
      type: "image",
    });
  }

  // :: 6.0 ScrollUp Active Code
  if ($.fn.scrollUp) {
    browserWindow.scrollUp({
      scrollSpeed: 1500,
      scrollText: '<i class="fa fa-angle-up"></i>',
    });
  }

  // :: 7.0 Sticky Active Code
  if ($.fn.sticky) {
    $(".crose-main-menu").sticky({
      topSpacing: 0,
    });
  }

  // :: 8.0 Tooltip Active Code
  if ($.fn.tooltip) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  // :: 9.0 prevent default a click
  $('a[href="#"]').on("click", function ($) {
    $.preventDefault();
  });

  // :: 10.0 wow Active Code
  /*if (browserWindow.width() > 767) {
    new WOW().init();
  }*/

  //newsletter
  

})(jQuery);

var ContactForm = (function() {
  // Variables

  var contactForm = ".contact-form",
    $contactForm = $(contactForm),
    $btnSubmit = $contactForm.find(".btn-submit-form"),
    $form = $contactForm.find(".form"),
    btnSubmitOriginalHtml = $btnSubmit.html(),
    $formResultSuccess = $contactForm.find(".form-result--success"),
    $formResultError = $contactForm.find(".form-result--error");

  // Methods

  function completeForm(isSuccess) {
    $btnSubmit.html(btnSubmitOriginalHtml).addClass("is-hidden");

    if (isSuccess) {
      $form.find(".form-control").val("");
      $formResultSuccess.removeClass("is-hidden");
    } else {
      $formResultError.removeClass("is-hidden");
    }

    setTimeout(function() {
      $contactForm.find(".contact-form__loading").remove();
      $formResultSuccess.addClass("is-hidden");
      $formResultError.addClass("is-hidden");
      $btnSubmit.removeClass("is-hidden");
    }, 3000);
  }

  function getErrorMsg($elem) {
    /*if (!$elem[0].validity.valid) {
      if ($elem[0].validity.valueMissing) {
        $elem[0].setCustomValidity(window.formInvalidFeedbacks.valueMissing);
      } else if ($elem[0].validity.typeMismatch) {
        $elem[0].setCustomValidity(window.formInvalidFeedbacks.typeMismatch);
      } else if ($elem[0].validity.patternMismatch) {
        $elem[0].setCustomValidity(window.formInvalidFeedbacks.patternMismatch);
      } else {
        $elem[0].setCustomValidity("");
      }
    } */

    return $elem[0].validationMessage;
  }

  function validate() {
    var hasError = false;

    $form
      .find(".form-control:not(.no-serialize):invalid")
      .each(function(index) {
        $(this)
          .parent()
          .find(".invalid-feedback")
          .text(getErrorMsg($(this)));
        if (index === 0) {
          $("html, body").animate(
            {
              scrollTop: $(this)
                .closest(".form-group")
                .offset().top
            },
            500
          );
        }
        hasError = true;
      });

    return hasError;
  }

  function init($contactForm) {
    $formResultSuccess.addClass("is-hidden");
    $formResultError.addClass("is-hidden");

    $btnSubmit.on("click", function(event) {
      event.preventDefault();

      $form.removeClass("was-validated");

      if (validate()) {
        $form.addClass("was-validated");
      } else {
        var serializedArray = $form
          .find(".form-control:not(.no-serialize)")
          .serializeArray();
        var formData = {};
        $(serializedArray).each(function(index, obj) {
          formData[obj.name] = obj.value;
        });

        $btnSubmit.find("i").attr("class", "fa fa-spinner fa-spin ml-2");
        $form.append('<div class="contact-form__loading"></div>');

        window.submitContactForm(formData, completeForm);
      }
    });
  }

  // // Events

  if ($contactForm.length) {
    init($contactForm);
  }
})();

var NewsletterForm = (function() {
  // Variables

  var newsletterForm = ".subscribe-area",
    $newsletterForm = $(newsletterForm),
    $btnSubmit = $newsletterForm.find(".btn-submit-form"),
    $form = $newsletterForm.find(".form"),
    btnSubmitOriginalHtml = $btnSubmit.html(),
    $success = $(newsletterForm).find(".subscribe-area__success"),
    $error = $(newsletterForm).find(".subscribe-area__error"),
    $fieldError = $(newsletterForm).find(".subscribe-area__field-error");

  // Methods

  function completeForm(isSuccess) {
    $btnSubmit.html(btnSubmitOriginalHtml);

    if (isSuccess) {
      $form.find(".form-control").val("");
      $success.removeClass("is-hidden");
    } else {
      $error.removeClass("is-hidden");
    }

    setTimeout(function() {
      $newsletterForm.find(".subscribe-area__loading").remove();
      $success.addClass("is-hidden");
      $error.addClass("is-hidden");
    }, 3000);
  }

  function validate() {
    var hasError = false;

    if (!$form.find(".form-control")[0].validity.valid) {
      var errMsg = $form.find(".form-control:invalid")[0].validationMessage;

      $fieldError.text(errMsg).removeClass("is-hidden");

      hasError = true;
    } else {
      $fieldError.text("").addClass("is-hidden");
    }

    return hasError;
  }

  function init($newsletterForm) {
    $success.addClass("is-hidden");
    $error.addClass("is-hidden");
    $fieldError.addClass("is-hidden");

    $form.find(".form-control").on("change keyup", function() {
      validate();
    });

    $btnSubmit.on("click", function(event) {
      event.preventDefault();

      if (!validate()) {
        var email = $form.find(".form-control").val();

        $btnSubmit.find("i").attr("class", "fa fa-spinner fa-spin ml-2");
        $form.append('<div class="subscribe-area__loading"></div>');

        window.submitNewsletterForm(email, completeForm);
      }
    });
  }

  // // Events

  if ($newsletterForm.length) {
    init($newsletterForm);
  }
})();

var Helpers = (function () {
  function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last, deferTimer;
    return function () {
      var context = scope || this;
      var now = +new Date(),
        args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }

  function isIE() {
    var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    var msie = ua.indexOf("MSIE "); // IE 10 or older
    var trident = ua.indexOf("Trident/"); //IE 11

    return msie > 0 || trident > 0;
  }

  function fixObjectFit() {
    if ("objectFit" in document.documentElement.style === false) {
      $("img[data-object-fit]").each(function () {
        var imgUri = $(this)
          .attr("src")
          .replace(/\(/g, "%28")
          .replace(/\)/g, "%29");
        $(this)
          .css({
            backgroundImage: "url(" + imgUri + ")",
            backgroundPosition: "center",
            backgroundSize: $(this).attr("data-object-fit"),
          })
          .attr(
            "src",
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
              $(this).width() +
              "' height='" +
              $(this).height() +
              "'%3E%3C/svg%3E"
          )
          .removeAttr("data-object-fit");
      });
    }
  }

  function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight,
      newHeight;
    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight != newHeight) callback();
      lastHeight = newHeight;

      if (elm.onElementHeightChangeTimer)
        clearTimeout(elm.onElementHeightChangeTimer);

      elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  }

  function generateRandomInteger(min, max) {
    return Math.floor(min + Math.random() * (max + 1 - min));
  }

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  }

  function setUrlParameter(query) {
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        query;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  return {
    throttle: function (fn, threshhold, scope) {
      return throttle(fn, threshhold, scope);
    },
    isIE: function () {
      return isIE();
    },
    fixObjectFit: function () {
      return fixObjectFit();
    },
    onElementHeightChange: function (elm, callback) {
      return onElementHeightChange(elm, callback);
    },
    generateRandomInteger(min, max) {
      return generateRandomInteger(min, max);
    },
    getUrlParameter(sParam) {
      return getUrlParameter(sParam);
    },
    setUrlParameter(query) {
      return setUrlParameter(query);
    },
  };
})();
